import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import { confirmCompletionClient, reportCompletionIssue } from '../../Store/Actions/actionOffer';

const CompletionConfirmationPanel = ({ demand, loading, confirmCompletion, reportIssue }) => {
  const [showIssue, setShowIssue] = useState(false);
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState('');
  if (demand?.demand_status !== 'completion_pending') return null;

  const runConfirm = async () => {
    setBusy('confirm');
    await confirmCompletion(demand);
    setBusy('');
  };
  const runIssue = async () => {
    if (reason.trim().length < 10) return;
    setBusy('issue');
    const success = await reportIssue(demand, reason);
    setBusy('');
    if (success) { setReason(''); setShowIssue(false); }
  };

  return (
    <Panel>
      <div>
        <strong>L’artisan a déclaré les travaux terminés</strong>
        <p>Vérifiez le chantier. Confirmez uniquement si les travaux correspondent au devis. Le paiement du solde reste bloqué jusqu’à votre décision.</p>
      </div>
      {showIssue && (
        <IssueBox>
          <label htmlFor={`completion-issue-${demand.demand_id}`}>Expliquez clairement le problème</label>
          <textarea id={`completion-issue-${demand.demand_id}`} value={reason} onChange={(event) => setReason(event.target.value)} maxLength={1200} placeholder="Ex. finition incomplète, élément du devis non réalisé…" />
          <small>{reason.length}/1200 caractères · 10 minimum</small>
        </IssueBox>
      )}
      <Actions>
        <IssueButton type="button" onClick={() => setShowIssue((value) => !value)} disabled={loading || Boolean(busy)}><ReportProblemOutlinedIcon />{showIssue ? 'Annuler le signalement' : 'Signaler un problème'}</IssueButton>
        {showIssue ? (
          <ConfirmButton type="button" onClick={runIssue} disabled={loading || Boolean(busy) || reason.trim().length < 10}>{busy === 'issue' ? 'Envoi…' : 'Envoyer le signalement'}</ConfirmButton>
        ) : (
          <ConfirmButton type="button" onClick={runConfirm} disabled={loading || Boolean(busy)}><CheckCircleOutlineIcon />{busy === 'confirm' ? 'Confirmation…' : 'Confirmer la fin des travaux'}</ConfirmButton>
        )}
      </Actions>
    </Panel>
  );
};

const Panel = styled.section`display:grid;gap:.8rem;margin-top:1rem;padding:1rem;border:1px solid #d5dfd8;border-radius:1rem;background:#f6fbf8;min-width:0;strong{font-size:.84rem}p{margin:.25rem 0 0;color:#57655d;font-size:.72rem;line-height:1.5}`;
const IssueBox = styled.div`display:grid;gap:.35rem;label{font-size:.72rem;font-weight:800}textarea{width:100%;min-height:6rem;padding:.7rem;border:1px solid #dacbc7;border-radius:.75rem;font:inherit;resize:vertical}small{justify-self:end;color:#7e706b;font-size:.62rem}`;
const Actions = styled.div`display:flex;flex-wrap:wrap;justify-content:flex-end;gap:.55rem;@media(max-width:34rem){flex-direction:column-reverse;button{width:100%;justify-content:center}}`;
const BaseButton = styled.button`display:inline-flex;align-items:center;gap:.35rem;min-height:2.65rem;padding:.62rem .85rem;border-radius:999px;font:inherit;font-size:.72rem;font-weight:850;cursor:pointer;svg{font-size:.95rem}&:disabled{opacity:.5;cursor:wait}`;
const IssueButton = styled(BaseButton)`border:1px solid #d4c6c1;background:#fff;color:#8b342e;`;
const ConfirmButton = styled(BaseButton)`border:1px solid #111;background:#111;color:#fff;`;

export default connect(({ demands }) => ({ loading: Boolean(demands?.loading) }), (dispatch) => ({
  confirmCompletion: (demand) => dispatch(confirmCompletionClient(demand)),
  reportIssue: (demand, reason) => dispatch(reportCompletionIssue(demand, reason)),
}))(CompletionConfirmationPanel);
